/**
 * 通用虚拟键盘按键数据
 * 支持多种格式：mouse (0x格式) 和 keyboard (#格式)
 */

const W = 0.52;
const M = 0.06;

// 基础按键数据（使用 HID 码作为 key）
export const mainKeys = {
  "0x29": { text: "Esc", style: { marginRight: M * 2 + W + "rem" } },
  "0x3a": { text: "F1" },
  "0x3b": { text: "F2" },
  "0x3c": { text: "F3" },
  "0x3d": { text: "F4", style: { marginRight: M + (M + W) * 0.5 + "rem" } },
  "0x3e": { text: "F5" },
  "0x3f": { text: "F6" },
  "0x40": { text: "F7" },
  "0x41": { text: "F8", style: { marginRight: M + (M + W) * 0.5 + "rem" } },
  "0x42": { text: "F9" },
  "0x43": { text: "F10" },
  "0x44": { text: "F11" },
  "0x45": { text: "F12" },
  "0x35": { text: "~<br/>`" },
  "0x1e": { text: "!<br/>1" },
  "0x1f": { text: "@<br/>2" },
  "0x20": { text: "#<br/>3" },
  "0x21": { text: "$<br/>4" },
  "0x22": { text: "%<br/>5" },
  "0x23": { text: "^<br/>6" },
  "0x24": { text: "&<br/>7" },
  "0x25": { text: "*<br/>8" },
  "0x26": { text: "(<br/>9" },
  "0x27": { text: ")<br/>0" },
  "0x2d": { text: "_<br/>-" },
  "0x2e": { text: "+<br/>=" },
  "0x2a": { text: "Backspace", style: { width: W * 2 + M + "rem" } },
  "0x2b": { text: "Tab", style: { width: W + (W + M) * 0.5 + "rem" } },
  "0x14": { text: "Q" },
  "0x1a": { text: "W" },
  "0x08": { text: "E" },
  "0x15": { text: "R" },
  "0x17": { text: "T" },
  "0x1c": { text: "Y" },
  "0x18": { text: "U" },
  "0x0c": { text: "I" },
  "0x12": { text: "O" },
  "0x13": { text: "P" },
  "0x2f": { text: "{<br/>[" },
  "0x30": { text: "}<br/>]" },
  "0x31": { text: "|<br/>\\", style: { width: W + (W + M) * 0.5 + "rem" } },
  "0x39": { text: "CapsLock", style: { width: W + W * 0.75 + M + "rem" } },
  "0x04": { text: "A" },
  "0x16": { text: "S" },
  "0x07": { text: "D" },
  "0x09": { text: "F" },
  "0x0a": { text: "G" },
  "0x0b": { text: "H" },
  "0x0d": { text: "J" },
  "0x0e": { text: "K" },
  "0x0f": { text: "L" },
  "0x33": { text: ":<br/>;" },
  "0x34": { text: "\"<br/>'" },
  "0x28": { text: "Enter", style: { width: W + W * 1.25 + M + "rem" } },
  "0xe1": { text: "LShift", style: { width: W + W * 1.25 + M * 1.5 + "rem" } },
  "0x1d": { text: "Z" },
  "0x1b": { text: "X" },
  "0x06": { text: "C" },
  "0x19": { text: "V" },
  "0x05": { text: "B" },
  "0x11": { text: "N" },
  "0x10": { text: "M" },
  "0x36": { text: "<<br/>," },
  "0x37": { text: "><br/>." },
  "0x38": { text: "?<br/>/" },
  "0xe5": { text: "RShift", style: { width: W + W * 1.75 + M * 1.5 + "rem" } },
  "0xe0": { text: "LCtrl ", style: { width: W * 1.3 + "rem" } },
  "0xe3": { text: "LCode", style: { width: W * 1.3 + "rem" } },
  "0xe2": { text: "LAlt", style: { width: W * 1.3 + "rem" } },
  "0x2c": { text: "Space", style: { width: W * 6.7 + "rem" } },
  "0xe6": { text: "RAlt", style: { width: W * 1.3 + "rem" } },
  "0xe7": { text: "RCode", style: { width: W * 1.3 + "rem" } },
  "0x65": { text: "Menu", style: { width: W * 1.3 + "rem" } },
  "0xe4": { text: "RCtrl", style: { width: W * 1.3 + "rem" } },
};

export const centerClusterKeys = {
  "0x46": { text: "Print Screen" },
  "0x47": { text: "Scroll Lock" },
  "0x48": { text: "Pause" },
  "0x49": { text: "Insert" },
  "0x4a": { text: "Home" },
  "0x4b": { text: "Page Up" },
  "0x4c": { text: "Delete" },
  "0x4d": { text: "End" },
  "0x4e": { text: "Page Down" },
  "0x52": { text: "↑", style: { marginTop: M + W + "rem", marginRight: M + W + "rem", marginLeft: M + W + "rem" } },
  "0x50": { text: "←" },
  "0x51": { text: "↓" },
  "0x4f": { text: "→" },
};

export const numpadKeys = {
  "0x53": { text: "Num Lock", style: { marginTop: M + W + "rem" } },
  "0x54": { text: "/", style: { marginTop: M + W + "rem" } },
  "0x55": { text: "*", style: { marginTop: M + W + "rem" } },
  "0x56": { text: "-", style: { marginTop: M + W + "rem" } },
  "0x5f": { text: "7" },
  "0x60": { text: "8" },
  "0x61": { text: "9" },
  "0x57": { text: "+" },
  "0x5c": { text: "4" },
  "0x5d": { text: "5" },
  "0x5e": { text: "6", style: { marginRight: M + W + "rem" } },
  "0x59": { text: "1" },
  "0x5a": { text: "2" },
  "0x5b": { text: "3", style: { marginRight: M + W + "rem" } },
  "0x62": { text: "0", style: { width: M + W * 2 + "rem" } },
  "0x63": { text: "." },
  "0x58": { text: "Enter" },
};

export const mouseKeys = {
  "0xf0": { text: "Left" },
  "0xf1": { text: "Right" },
  "0xf2": { text: "Wheel" },
  "0xf3": { text: "Back" },
  "0xf4": { text: "Forward" },
};

export const allKeys = {
  ...mainKeys,
  ...centerClusterKeys,
  ...numpadKeys,
  ...mouseKeys,
};

/**
 * 格式转换工具
 */
export const formatUtils = {
  /**
   * 键盘格式 → 内部格式（0x）
   * #11070004 → 0x1104
   * @param {string} key - 键盘格式的按键码
   * @returns {string} 内部格式的按键码
   */
  keyboardToInternal(key) {
    if (!key || typeof key !== 'string') return key;
    if (!key.startsWith('#')) return key;
    
    const state = key.substring(1, 3);  // "11" 或 "10"
    const hid = key.substring(7);        // "04"
    return ('0x' + state + hid).toLowerCase();
  },

  /**
   * 内部格式（0x）→ 键盘格式
   * 0x1104 → #11070004（带状态）
   * 0x04 → #00070004（无状态）
   * @param {string} key - 内部格式的按键码
   * @returns {string} 键盘格式的按键码
   */
  internalToKeyboard(key) {
    if (!key || typeof key !== 'string') return key;
    if (!key.startsWith('0x')) return key;
    
    const hex = key.substring(2);  // 去掉 "0x"
    
    // 如果是带状态的（4位：1104）
    if (hex.length === 4) {
      const state = hex.substring(0, 2);  // "11" 或 "10"
      const hid = hex.substring(2);        // "04"
      return '#' + state + '0700' + hid.toUpperCase();
    }
    
    // 如果是基础按键（2位：04）
    if (hex.length === 2) {
      return '#000700' + hex.toUpperCase();
    }
    
    return key;
  },

  /**
   * 鼠标格式 → 内部格式（直接返回，格式相同）
   * @param {string} key - 鼠标格式的按键码
   * @returns {string} 内部格式的按键码
   */
  mouseToInternal(key) {
    return key;
  },

  /**
   * 内部格式 → 鼠标格式（直接返回，格式相同）
   * @param {string} key - 内部格式的按键码
   * @returns {string} 鼠标格式的按键码
   */
  internalToMouse(key) {
    return key;
  },

  /**
   * 获取基础按键码（去掉状态前缀）
   * 0x1104 → 0x04
   * @param {string} key - 带状态的按键码
   * @returns {string} 基础按键码
   */
  getBaseKey(key) {
    if (!key || typeof key !== 'string') return key;
    if (!key.startsWith('0x')) return key;
    
    // 处理鼠标按键（0xf0-0xf4）
    if (key.toLowerCase().includes('0xf') || key.includes('0x00f') || key.includes('0x0f')) {
      return key.replace(/0x1[01]/gi, '0x').replace(/0x00/gi, '0x').replace(/00$/, '').toLowerCase();
    }
    
    // 处理键盘按键，返回小写
    return key.replace(/0x1[01]/gi, '0x').toLowerCase();
  },

  /**
   * 判断是否为按下状态
   * @param {string} key - 按键码
   * @returns {boolean}
   */
  isDownState(key) {
    if (!key || typeof key !== 'string') return true;
    return key.includes('0x11') || key.includes('0x00');
  },
};

export default {
  mainKeys,
  centerClusterKeys,
  numpadKeys,
  mouseKeys,
  allKeys,
  formatUtils,
};
